/**
 * 轻量前端日志工具。
 *
 * - 开发环境: debug 及以上输出到 console
 * - 生产环境: warn 及以上输出到 console (未来可扩展发送远端)
 */
type Level = "debug" | "info" | "warn" | "error";

const LEVEL_RANK: Record<Level, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

const minLevel: Level = import.meta.env.PROD ? "warn" : "debug";

function emit(level: Level, msg: string, ctx?: Record<string, unknown>) {
  if (LEVEL_RANK[level] < LEVEL_RANK[minLevel]) return;

  const entry = { ts: new Date().toISOString(), level, msg, ...ctx };
  const method = level === "debug" ? "log" : level;

  console[method](`[${level.toUpperCase()}]`, msg, ctx ?? "");

  // 生产环境错误可在此扩展: 发送到后端 /api/v1/log 或 Sentry
  if (import.meta.env.PROD && level === "error") {
    void entry; // placeholder
  }
}

export const logger = {
  debug: (msg: string, ctx?: Record<string, unknown>) => emit("debug", msg, ctx),
  info: (msg: string, ctx?: Record<string, unknown>) => emit("info", msg, ctx),
  warn: (msg: string, ctx?: Record<string, unknown>) => emit("warn", msg, ctx),
  error: (msg: string, ctx?: Record<string, unknown>) => emit("error", msg, ctx),
};
